import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { createOfflineCommonRepository } from './common/createOfflineCommonRepository';

export const offlineProductColorPriceInfoRepository = {
  ...createOfflineCommonRepository(() => offlineDatabase.productColorsPriceInfo),
  findByIds: null,
  getById: (productColorId: string, priceTableId: string) => {
    return offlineDatabase.productColorsPriceInfo.get({ productColorId, priceTableId });
  },
  getByIdOrFail: async (productColorId: string, priceTableId: string) => {
    const priceInfo = await offlineProductColorPriceInfoRepository.getById(
      productColorId,
      priceTableId,
    );
    if (!priceInfo) {
      throw new Error('product color price info not found');
    }
    return priceInfo;
  },
  findByProductColorIds: async (productColorIds: string[], priceTableId: string) => {
    return offlineDatabase.productColorsPriceInfo
      .where('[productColorId+priceTableId]')
      .anyOf(productColorIds.map((id) => [id, priceTableId]))
      .toArray();
  },
  findAllByProductColorId: async (productColorId: string) => {
    return offlineDatabase.productColorsPriceInfo
      .where('productColorId')
      .equals(productColorId)
      .toArray();
  },
  findAllByProductColorIds: async (productColorIds: string[]) => {
    return offlineDatabase.productColorsPriceInfo
      .where('productColorId')
      .anyOf(productColorIds)
      .toArray();
  },
};
